import BillingsPlanEntryTaxiDriverDraftRequest from "../../../../../api/raily/billings/plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft.request";
import BillingsPlanEntryTaxiDriverDraftParams from "./billings-plan-entry-taxi-driver-draft-params";

const create = (
  params: BillingsPlanEntryTaxiDriverDraftParams,
): BillingsPlanEntryTaxiDriverDraftRequest => {
  return {
    planEntryId: params.planEntryId,
  };
};

const billingsPlanEntryTaxiDriverDraftParamsFactory = {
  create,
};

export default billingsPlanEntryTaxiDriverDraftParamsFactory;
